import { render, staticRenderFns } from "./index-classic-app.vue?vue&type=template&id=1fcae34c&"
import script from "./index-classic-app.vue?vue&type=script&lang=js&"
export * from "./index-classic-app.vue?vue&type=script&lang=js&"
import style0 from "./index-classic-app.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports